<div class="reset-password-container header-text p-6">
    <div class="header">
        <h2 class="black-text lightest-text m-0">{{metaData.labels[0]}}</h2>
        <img mat-dialog-close src="assets/close-dialog.svg" (click)="cancel_click()">
    </div>
    <div class="body-wrapper" [formGroup]="pwd">
        <p class="mandatory-field alert-text mb-0 pt-0 pr-2 pb-0 pl-0 content-s">* mandatory</p>
        <div class="body-row-1 mt-1">
            <label class="label-text bold-text span-m pt-2">
                {{metaData.labels[1]}}<span class="alert-text">*</span>
            </label>
            <div class="body-row-1-col-2"> 
                <div class="input-box-type">
                    <input class=" input-border" formControlName="oldpassword" [type]="showPass1 ? 'text' : 'password' "
                        [placeholder]="inputPlaceholders[0]">
                </div>
                <div class="alert-danger alert-text span-s" *ngIf="oldpassword.touched || errorMessage">
                    {{validationData.password.errors|oneError:oldpassword.errors}}</div>
            </div>
            <div class="body-row-1-col-3 mt-2">
                <img class="preview-hide-1" src="assets/preview_hide.svg" (click)="showPass1 =! showPass1"
                    *ngIf="!showPass1">
                <img class="preview-1" src="assets/preview.svg" (click)="showPass1 =! showPass1" *ngIf="showPass1">
            </div>
        </div>
        <div class="body-row-2 mt-1">
            <label class="label-text bold-text span-m pt-2">
                {{metaData.labels[2]}}<span>*</span>
            </label>
            <div class="body-row-2-col-2">
                <div class="input-box-type">
                    <input class="input-border" formControlName="newpassword" [type]="showPass2?'text':'password'"
                        [placeholder]="inputPlaceholders[1]">
                </div>
                <div class="alert-danger alert-text span-s" *ngIf="passwordnew.touched || errorMessage">
                    <div *ngIf="passwordnew.invalid">{{validationData.password.errors |oneError:passwordnew.errors}}</div>
                </div>
                </div>
            <div class="body-row-2-col-3 mt-2">
                <img class="preview-hide-1" src="assets/preview_hide.svg" (click)="showPass2 =! showPass2"
                    *ngIf="!showPass2">
                <img class="preview-1" src="assets/preview.svg" (click)="showPass2 =! showPass2" *ngIf="showPass2">
            </div>
        </div>
        <div class="body-row-3 mt-1">
            <label class="label-text bold-text span-m pt-2">
                {{metaData.labels[3]}}<span>*</span>
            </label>
            <div class="body-row-3-col-2 mt-2">
                <div class="input-box-type">
                    <input class="input-border" formControlName="reenterpassword" [type]="showPass3?'text':'password'"
                        [placeholder]="inputPlaceholders[1]">
                </div>
                <div class="alert-danger alert-text span-s" *ngIf="reEnterPwd.touched||errorMessage">
                    <div *ngIf="reEnterPwd.invalid">{{validationData.password.errors |oneError:reEnterPwd.errors}}</div>
                    <div *ngIf="reEnterPwd.invalid && reEnterPwd.errors.confirmedValidator">
                        {{validationData.password.errors.pwdnotmatch }}</div>
                </div>
            </div>
            <div class="body-row-3-col-3">
                <img class="preview-hide-1" src="assets/preview_hide.svg" (click)="showPass3 =! showPass3"
                    *ngIf="!showPass3">
                <img class="preview-1" src="assets/preview.svg" (click)="showPass3 =! showPass3" *ngIf="showPass3">
            </div>

        </div> 
    </div>
    <div class="footer mt-3">
        <div class="footer-buttons">
            <button class="cancel " mat-dialog-close (click)="cancel_click()">{{commonData.buttonLabels.cancel}}</button>
            <button class="submit " (click)="submit_click()">{{commonData.buttonLabels.submit}}</button>
        </div>
    </div>

</div>
<ng-container *ngIf="resetPasswordSpinner">
    <div class="reset-spinner secondary-side-nav-bg">
        <mat-spinner class="spinner mx-2 my-auto" diameter=20></mat-spinner>
    </div>
</ng-container>